import { Component } from 'react';

import PropTypes from 'prop-types';

import AppErrorState from '@components/common/AppErrorState';
import { globalErrorHandler } from '@services/api/errorHandler';

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    globalErrorHandler(error, errorInfo);
    this.props.onError?.(error, errorInfo);
  }

  handleRetry = () => {
    this.setState({ hasError: false });
  };

  render() {
    if (this.state.hasError) {
      if (this.props.fallback) {
        return this.props.fallback;
      }

      return (
        <AppErrorState
          title={this.props.title}
          description={this.props.description}
          onRetry={this.handleRetry}
        />
      );
    }

    return this.props.children;
  }
}

ErrorBoundary.propTypes = {
  children: PropTypes.node.isRequired,
  fallback: PropTypes.node,
  title: PropTypes.string,
  description: PropTypes.string,
  onError: PropTypes.func,
};

ErrorBoundary.defaultProps = {
  title: 'Something went wrong',
  description: 'An unexpected error occurred while rendering this view.',
};

export default ErrorBoundary;
